// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2fz0w","text":"SelectPayment_text__32UbX","title":"SelectPayment_title__iRo5z","btn":"SelectPayment_btn__9eHfk"};